function isBreakpoint(breakpoint) {
	var testDiv
	, boolBP;

	testDiv = $('<div/>')
		.addClass('visible-' + breakpoint)
		.appendTo($('body'));
	boolBP = testDiv.is(':visible');
	testDiv.remove();
	return boolBP; 	console.log(boolBP);
};

/*
// usage:

	if (isBreakpoint(lg) ) {
		// viewport is > @screen-lg
	}
	
*/